import { FramesView } from "frontend/app-footer/views/frames-view/frames-view";
import { ZoomView } from "frontend/app-footer/views/zoom-view/zoom-view";

export const AppFooter = () => {
  return (
    <>
      <ZoomView />
      <FramesView />
    </>
  );
};
